<template>
  <!-- <div class="bg-green-500">
    <portal-target name="dropdown" slim />

    <div class="md:flex md:flex-col bg-red-400">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          <div
            class="
              bg-gray-800
              border-b
              w-full
              p-4
              md:py-0 md:px-12
              text-sm
              md:text-md
              flex
              justify-between
              items-center
            "
          >
            <div class="flex w-72 py-4">
              <inertia-link class="btn-indigo" :href="route('dashboard')">
                <icon class="w-5 h-5 fill-white" name="return" />
              </inertia-link>
            </div>

            <div class="m-auto">
              <inertia-link
                :href="
                  route(
                    window.location.pathname === '/indicators/compare' ||
                      window.location.pathname === '/indicators/config'
                      ? 'indicators'
                      : 'indicators.start',
                  )
                "
              >
                <img :src="'/logo.png'" alt="Logo" width="100" />
              </inertia-link>
            </div>

            <div class="flex items-center select-none group">
              <div class="text-white mr-1 whitespace-nowrap">
                <span
                  >Olá,
                  <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span
                >
                <span class="hidden md:inline"
                  ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span
                >
              </div>

              <inertia-link
                v-if="$page.props.auth.user.roles.includes('indicators-order')"
                :href="route('indicators.config')"
              >
                <icon class="w-5 h-5 ml-3 fill-white" name="gear" />
              </inertia-link>
            </div>
          </div>
        </div>

        <div class="md:flex md:flex-grow md:overflow-hidden" style="margin-top: -1px">
          <indicators-menu
            v-if="window.location.pathname !== '/indicators/compare'"
            id="i-menu"
            ref="menu"
            class="md:block flex-shrink-0 w-56 bg-white border-t overflow-y-auto"
          />

          <div class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <section class="flex max-w-full w-screen min-h-screen">
    <portal-target name="dropdown" slim class="teste" />
    <div class="container_navigation w-80 min-h-screen fixed p-5 pb-5">
      <indicators-menu
        v-if="window.location.pathname !== '/indicators/compare'"
        id="i-menu"
        ref="menu"
      />
    </div>
    <div class="container_content w-full min-h-screen p-10">
      <div class="header w-full h-14 flex justify-between items-center mb-10">
        <div class="flex items-center justify-center gap-7">
          <div class="cursor-pointer">
            <inertia-link href="/">
              <img src="/goback.svg" alt="Voltar" />
            </inertia-link>
          </div>
          <div class="h-10 w-52">
            <inertia-link href="/">
              <img :src="'/logo-slim-dark.png'" alt="Logo" class="w-full h-full" />
            </inertia-link>
          </div>
        </div>
        <div class="flex gap-3">
          <p>
            <span
              >Olá,
              <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span
            >
            <span class="hidden md:inline"
              ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span
            >
          </p>
          <inertia-link :href="route('users.edit', $page.props.auth.user.id)">
            <icon class="w-5 h-5 ml-3" name="user" style="fill: #00a39a" />
          </inertia-link>

          <inertia-link :href="route('logout')" method="delete">
            <icon class="w-5 h-5 ml-3" name="exit" style="fill: #00a39a" />
          </inertia-link>
        </div>
      </div>
      <div class="">
        <flash-messages />
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import IndicatorsMenu from '@/Pages/Indicators/Menu'

export default {
  components: {
    FlashMessages,
    Icon,
    IndicatorsMenu,
  },
  data() {
    return {
      get window() {
        return window
      },
    }
  },
  methods: {
    showMenus(show = true) {
      const menu = document.getElementById('i-menu')

      if (show) {
        menu.classList.add('md:block')
        menu.classList.remove('hidden')

        return
      }

      menu.classList.remove('md:block')
      menu.classList.add('hidden')
    },
    refreshMenus() {
      this.$refs?.menu?.reactivate()
    },
    activeMenu() {
      return this.$refs?.menu?.active
    },
  },
}
</script>

<style scoped>
section {
}

.container_navigation {
  min-width: 300px;
  max-width: 320px;
  height: 100vh;
}

.container_content {
  width: 100vw;
  max-width: 100%;
  padding-left: 340px;
}

@media screen and (max-width: 1000px) {
  section {
    display: flex;
    flex-direction: column;
  }

  .container_navigation {
    position: static;
    width: 100vw;
    max-width: 100%;
    min-height: 90px;
    height: 90px;
    background-color: #1e293b;
  }

  .container_content {
    padding-left: 20px;
    height: 100%;
  }
}
</style>
